import { Injectable } from '@angular/core';
import { AuthData } from '../providers/auth';
import * as firebase from 'firebase';

@Injectable()

export class StorageFb {

  constructor(
    private auth: AuthData
  ) { }

  uploadNote(file) {

    return new Promise((resolve, reject) => {
      resolve(firebase.storage().ref('/Notes/' + this.auth.getUser().uid + '/' + file.name).put(file));
    });
  }

  uploadAvatar(file: File, userId: string) {
    return firebase.storage().ref(`/Client/Users/${userId}`).put(file);
    // return new Promise((resolve, reject) => {
    //   resolve(firebase.storage().ref('/Clients/' + client.id + '/Profile/' + this.auth.getUser().uid + '/' + file.name).put(file));
    // });
  }

}
// end file



// WEBPACK FOOTER //
// ./src/providers/storage.ts